export function useSupabaseUrl() {
  const runtimeConfig = useRuntimeConfig();
  return (
    runtimeConfig?.public?.supabase?.url ||
    "https://nmywglyfswckroxbrjqz.supabase.co"
  );
}

export function useSupabaseAnonKey() {
  const runtimeConfig = useRuntimeConfig();
  return (
    runtimeConfig?.public?.supabase?.key ||
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5teXdnbHlmc3dja3JveGJyanF6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODMyOTY1MDEsImV4cCI6MTk5ODg3MjUwMX0.gz1KDjm1aOANpn6bZaZMCaLESwdMHO3CXX2R7aoieMs"
  );
}
